<script>
import con from '@services/connection'
import { user, sendLink, comunicacaoPush } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import { possivelJSON } from '@utils/Format'
import store from '@state/store'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

export default {
  components: {
    Title,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      rules: rules,
      step: 1,
      loadingClients: false,
      loading: false,
      clients: [],
      selectedsClients: [],
      searchClient: '',
      showClients: true,
      headersClients: [
        {
          text: 'Nome',
          align: 'left',
          value: 'nome_cliente',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ],
      titulo: '',
      descricao: '',
      link: '',
      tipo: 'texto',
      showUrl: true,
      fixComunicado: false,
      enviar_feed: true,
      enviar_notificacao: false,
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    showHeader() {
      return this.showClients
    },
    subtitle() {
      if (this.selectedsClients.length) {
        if (this.selectedsClients.length === 1) {
          if (this.selectedsClients[0].name || this.selectedsClients[0].nome) {
            return (
              this.selectedsClients[0].name || this.selectedsClients[0].nome
            )
          }
        }
        return `${
          [...new Set(this.selectedsClients)].length
        } clientes selecionados`
      }
      return ''
    },
  },
  created() {
    GlobalBus.$on(MODAL.SEND_COMUNICATE, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.SEND_COMUNICATE, this.open)
  },
  methods: {
    open(c) {
      this.step = 1
      this.selectedsClients = []
      this.clear()

      if (c && c.clientes) {
        this.showClients = false
        if (typeof c.clientes === 'object' && c.clientes.length) {
          this.selectedsClients = c.clientes
        } else {
          this.selectedsClients = [c.clientes]
        }
        this.step = 2
      } else {
        this.getClients()
      }

      if (c && c.noticia) {
        this.titulo = c.noticia.titulo
        this.descricao = c.noticia.descricao
        this.link = c.noticia.url
        this.tipo = c.noticia.tipo || 'texto'
      }

      this.showUrl = !c.hideUrl
      this.fixComunicado = c.fixComunicado

      this.busModal.$emit('dialog', true)
    },
    teste() {
      console.log('select all')
    },
    clear() {
      this.step = 1
      this.selectedsClients = []
      this.searchClient = ''
      this.showClients = true
      this.titulo = ''
      this.descricao = ''
      this.link = ''
      this.enviar_feed = true
      this.enviar_notificacao = false
      this.loadingClients = false
      this.loading = false
      this.clients = []
    },
    openNewClient() {
      this.bus.$emit(MODAL.CADASTRAR_CLIENTES, true)
    },
    getClients() {
      if (this.loadingClients) {
        return
      }
      this.loadingClients = true
      con.get(sendLink.listar_clientes).then((res) => {
        if (res && res.status == 200) {
          this.clients = possivelJSON(res.value)
        }
        this.loadingClients = false
      })
    },
    selectedClients(input) {
      this.selectedsClients = [input]
      this.step = Number(this.step) + 1
    },
    continuar() {
      if (this.selectedsClients.length) {
        this.step = Number(this.step) + 1
      } else {
        this.$showSnack({
          text: 'Selecione pelo menos um cliente',
          button: true,
        })
      }
    },
    async enviar() {
      if (this.loading) {
        return
      }
      this.loading = true
      if (
        this.$refs.form.validate() &&
        (this.enviar_feed || this.enviar_notificacao)
      ) {
        const ids = JSON.stringify(
          this.selectedsClients.map((c) => {
            return c.id
          })
        )
        const data = {
          conteudo: this.descricao,
          nome: this.titulo,
          clientes: ids,
          send_push: this.enviar_notificacao,
          send_feed: this.enviar_feed,
          title: 'Comunicado',
          tipo: this.tipo,
          url: this.link,
        }
        const url = comunicacaoPush.enviar
        const r = await con.post(url, data)
        if (r.status === 200) {
          this.busModal.$emit('dialog', false)
          this.$showSnack({
            text: `Enviado com sucesso`,
            button: true,
          })
        } else {
          this.$showSnack({
            text: r.message,
            button: true,
          })
        }
      }
      this.loading = false
    },
    selectAllClients(check) {
      this.selectedsClients = check ? this.clients : []
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="900px" persistent>
    <Title title="Enviar comunicado" :subtitle="subtitle" />

    <div class="v-application">
      <v-stepper v-model="step" style="width: 100%;" class="elevation-0">
        <v-stepper-header v-if="showHeader" class="elevation-0">
          <v-stepper-step v-if="showClients" :editable="step > 1" step="1">
            Escolha o(os) clientes
          </v-stepper-step>
          <v-divider />
          <v-stepper-step :editable="step > 2" step="2">
            Enviar o comunicado
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="elevation-0">
          <v-stepper-content step="1">
            <div class="input-group align-items-center pb-2">
              <v-text-field
                v-model="searchClient"
                label=""
                placeholder="Procurar cliente"
                single-line
                hide-details
                class="input short-search"
                :class="$style.alignCenter"
                append-icon=" "
                style="max-height: 42px; min-height: 42px !important; margin-top: 6px !important"
                full-width
              ></v-text-field>
              <button
                class="btn btn-icon btn-icon-secondary align-self-center"
                style="margin-top: 4px"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19.276"
                  height="19.966"
                  viewBox="0 0 19.276 19.966"
                >
                  <path
                    class="fill"
                    d="M19.967 18.186l-4.752-4.942a8.058 8.058 0 1 0-6.17 2.879 7.975 7.975 0 0 0 4.618-1.459l4.788 4.98a1.051 1.051 0 1 0 1.516-1.458zM9.045 2.1a5.958 5.958 0 1 1-5.958 5.961A5.965 5.965 0 0 1 9.045 2.1z"
                    transform="translate(-.984)"
                  />
                </svg>
              </button>
            </div>
            <v-data-table
              v-if="showClients"
              v-model="selectedsClients"
              :headers="headersClients"
              :items="clients"
              show-select
              height="235"
              item-key="login"
              :search="searchClient"
              :loading="loadingClients"
              fixed-header
              @toggle-select-all="teste"
            >
              <template v-slot:header.data-table-select="{}">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-checkbox
                        :key="
                          selectedsClients.length > 0 &&
                            selectedsClients.length != clients.length
                        "
                        color="gray"
                        :indeterminate="
                          selectedsClients.length > 0 &&
                            selectedsClients.length != clients.length
                        "
                        :input-value="
                          selectedsClients.length === clients.length &&
                            !loadingClients
                        "
                        @change="selectAllClients"
                      />
                    </div>
                  </template>
                  <span>{{
                    selectedsClients.length != clients.length
                      ? 'Selecionar todos'
                      : 'Deselecionar todos'
                  }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.nome_cliente="{ item }">
                <td>
                  <v-row style="align-items: center;">
                    <v-icon
                      v-if="!item.id_cadastro_cliente"
                      small
                      right
                      color="primary"
                    >
                      mdi-account
                    </v-icon>
                    <v-icon v-else small right>
                      mdi-account-switch
                    </v-icon>
                    <p style="margin-bottom: 0px; margin-left: 5px">
                      {{ item.nome_cliente }}
                    </p>
                  </v-row>
                </td>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn text icon small @click="selectedClients(item)">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <p class="pt-3">Nenhum cliente encontrado</p>
                <BaseButton primary small @click="openNewClient">
                  <strong>+</strong> Cliente
                </BaseButton>
              </template>
            </v-data-table>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row>
              <v-col cols="6">
                <v-form ref="form">
                  <v-text-field
                    v-model="titulo"
                    label="Título*"
                    :rules="[rules.required]"
                  />
                  <v-textarea
                    v-model="descricao"
                    label="Descrição*"
                    :rules="[rules.required]"
                  />
                  <v-text-field v-if="showUrl" v-model="link" label="URL" />
                  <v-row>
                    <v-col cols="6">
                      <v-checkbox
                        v-model="enviar_feed"
                        :readonly="fixComunicado"
                        label="Comunicado"
                        :ripple="false"
                      >
                        <template v-slot:append>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                x-small
                                style="margin-top: 8px; margin-left: 10px;"
                                v-on="on"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>
                              Enviar um comunicado para o cliente, deixando
                              salvo
                              <br />
                              para visualização à qualquer momento.
                            </span>
                          </v-tooltip>
                        </template>
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <v-checkbox
                        v-model="enviar_notificacao"
                        label="Notificação"
                      >
                        <template v-slot:append>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                x-small
                                style="margin-top: 8px; margin-left: 10px;"
                                v-on="on"
                              >
                                mdi-information-outline
                              </v-icon>
                            </template>
                            <span>
                              Enviar uma notificação para o cliente, semelhante
                              <br />
                              aos enviados por aplicativos de redes sociais.
                            </span>
                          </v-tooltip>
                        </template>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
              <v-col cols="6">
                <p class="subhead">Preview</p>
                <div class="feed-card shadow">
                  <div class="feed-card__info">
                    <div class="feed-card__info__title">
                      {{ titulo.toUpperCase() }}
                    </div>
                    <div class="feed-card__info__description">
                      {{ descricao }}
                    </div>
                    <div
                      v-if="tipo != 'pdf'"
                      style="display: flex; align-items: center;"
                    >
                      <div style="font-weight: bold;"> Saiba mais </div>
                      <a :href="link" target="_blank" style="margin-left: 5px;">
                        <div
                          style="background-color: var(--primary); width: 25px; height: 25px; border-radius: 60px; color: #FFF; align-items: center; justify-content: center; display: flex;"
                        >
                          <span style="font-size: 20px;height: 20px;">
                            <b>+</b>
                          </span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Sair
      </BaseButton>
      <BaseButton v-if="step == 1" primary @click="continuar">
        Continuar
      </BaseButton>
      <BaseButton v-if="step == 2" primary :loading="loading" @click="enviar">
        Enviar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<style lang="sass" module>
.buttons_centralize
  padding-left: 10px
  padding-right: 10px

.row_cadastrar_cliente
  align-items: center
  justify-content: center

.v-text-field v-label
  margin-top: 6px !important
.v-text-field__slot input
  margin-top: 6px !important

.alignCenter
  input
    margin-top: 0px !important
</style>

<style scoped>
.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.feed-card {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 95%;
  margin: 0 0 20px;
  padding: 30px;
  overflow: hidden;
  border-radius: 30px;
  text-align: left;
  color: #f8f8f8;
  background: #f8f8f8;
  box-shadow: 0 10px 10px 0 rgba(129, 93, 152, 0.05);
}

.feed-card__info > * {
  color: #2b252e;
}

.feed-card .icon--primary .tint {
  fill: var(--primary) !important;
  color: #fff;
}

.feed-card__info {
  position: relative;
  width: 100%;
  font-size: 12px;
  line-height: 16px;
}

.feed-card__info__title {
  margin: 0 0 17px;
  padding: 0 0 8px;
  font-weight: bold;
  border-bottom: 3px solid var(--primary);
}

.feed-card__info__description {
  margin: 0 0 15px;
  line-height: 16px;
}
</style>
